import { useEffect, useState } from "react";
import {
  BookMarked,
  Hammer,
  LockKeyhole,
  ScrollText,
  type User,
} from "lucide-react";

export type BottomTab = "codex" | "builder" | "vault" | "corpus";
export type CodexSubTab = "framework" | "voice" | "avatar";

export type BottomDockCount = { current: number; max?: number | null };

export const formatCount = (count?: BottomDockCount) => {
  if (!count) return null;
  if (count.max == null) return String(count.current);
  return `${count.current}/${count.max}`;
};

export const RAIL_WIDTH_KEY = (ws: string | undefined, side: "left" | "right") =>
  `composer.shell.${side}.${ws ?? "anon"}`;
export const RAIL_OPEN_KEY = (ws: string | undefined, side: "left" | "right") =>
  `composer.shell.${side}.open.${ws ?? "anon"}`;
export const BOTTOM_DOCK_TAB_KEY = (ws: string | undefined) =>
  `composer.shell.bottomDock.tab.${ws ?? "anon"}`;
export const BOTTOM_DOCK_HEIGHT_KEY = (ws: string | undefined) =>
  `composer.shell.bottomDock.height.${ws ?? "anon"}`;
export const CODEX_SUB_TAB_KEY = (ws: string | undefined) =>
  `composer.shell.codex.tab.${ws ?? "anon"}`;

export const useViewportWidth = () => {
  const [w, setW] = useState(() => (typeof window === "undefined" ? 1440 : window.innerWidth));
  useEffect(() => {
    const handler = () => setW(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return w;
};

export const BOTTOM_TABS: { id: BottomTab; label: string; Icon: typeof User }[] = [
  { id: "codex", label: "Codex", Icon: BookMarked },
  { id: "builder", label: "Builder", Icon: Hammer },
  { id: "vault", label: "Vault", Icon: LockKeyhole },
  { id: "corpus", label: "Corpus", Icon: ScrollText },
];

export const LEGACY_TAB_MAP: Record<string, BottomTab> = {
  framework: "codex",
  voice: "codex",
  avatar: "codex",
  codex: "codex",
  builder: "builder",
  vault: "vault",
  briefs: "corpus",
  corpus: "corpus",
};
